import { httpAdmin, httpEnrollmentClient } from '@/services/common/httpClient';
import axios, { AxiosResponse } from 'axios';
import {
  AddCartItemRequest,
  GetCartApplicationsResponse,
  GetCartResponse,
  RemoveCartItemRequest,
  StorePolicy,
  UpdateCartItemRequest,
  getCartParams,
  AssociateScholarToCartItemRequest,
  CustomCheckoutOption
} from '@/Model/checkout/cart/types';
import API_CONST from '@/constants/ApiConst';

let getCartCancelTokenSource = axios.CancelToken.source();
let getCartApplicationsCancelTokenSource = axios.CancelToken.source();

export function getCartForUser(
  userId: number,
  accountId: number,
  calculateCartComplete: boolean = false,
  promoCode: string = ''
): Promise<AxiosResponse<GetCartResponse>> {
  getCartCancelTokenSource.cancel();
  getCartCancelTokenSource = axios.CancelToken.source();
  const params: getCartParams = {
    userId,
    accountId,
  };
  if (calculateCartComplete) {
    params.calcCartComplete = calculateCartComplete;
  }
  if (promoCode) {
    params.promoCode = promoCode;
  }
  return httpEnrollmentClient().get<GetCartResponse>(API_CONST.CART_GET, {
    params,
    cancelToken: getCartCancelTokenSource.token,
  });
}

export function removeCartItem(
  request: RemoveCartItemRequest
): Promise<AxiosResponse> {
  return httpEnrollmentClient().post(API_CONST.CART_REMOVE_CART_ITEM, request);
}

export function addNewItem(
  request: AddCartItemRequest
): Promise<AxiosResponse> {
  return httpEnrollmentClient().post(API_CONST.CART_ADD_CART_ITEM, request);
}

export function updateItem(
  request: UpdateCartItemRequest
): Promise<AxiosResponse> {
  return httpEnrollmentClient().post(API_CONST.CART_UPDATE_CART_ITEM, request);
}

export function getCartApplications(
  userId: number,
  accountId: number
): Promise<AxiosResponse<GetCartApplicationsResponse>> {
  getCartApplicationsCancelTokenSource.cancel();
  getCartApplicationsCancelTokenSource = axios.CancelToken.source();
  return httpEnrollmentClient().get<GetCartApplicationsResponse>(
    API_CONST.CART_GET_CART_APPLICATIONS,
    {
      params: {
        userId,
        accountId,
      },
      cancelToken: getCartApplicationsCancelTokenSource.token,
    }
  );
}

export function getTermsOfService(
  accountId: number
): Promise<AxiosResponse<StorePolicy>> {
  return httpAdmin().get<StorePolicy>(API_CONST.TERMS_OF_SERVICE, {
    params: {
      accountId,
    },
  });
}

export function associateScholar(
  request: AssociateScholarToCartItemRequest
): Promise<AxiosResponse> {
  return httpEnrollmentClient().post(API_CONST.ASSOCIATE_SCHOLAR, request);
}

export function getCustomCheckoutOptionList(
  accountId: number
) {
  return httpAdmin({ interceptor: true }).get<CustomCheckoutOption[]>(
    `${API_CONST.CUSTOM_CHECKOUT}/listbyaccountid/${accountId}`
  );
}